module.exports = __webpack_public_path__ + "static/media/party-popper.5f550814.gif";